module.exports = "<div  uib-tooltip=\"{{date}}\"\n      uib-tooltip-placement=\"top\"\n      uib-tooltip-animation=\"false\"\n      uib-tooltip-trigger=\"mouseenter\"\n      uib-tooltip-append-to-body=\"true\">{{date}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-time-ago/dc-time-ago.tpl.html
// module id = 943
// module chunks = 12